import type { Dispatch, ReactElement, SetStateAction } from 'react';
import {
  type Campaign,
  Status_Enum as CampaignStatus,
  type Usage,
} from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import type { FieldProps, ModalControlModalProps } from '@frontend/design-system';

export type CampaignGroup = {
  month: number;
  campaigns: Campaign[];
  usage: Usage;
};

export type ContainerSize = 'small' | 'large';
// TODO: Change "compose" to "composer" and "new-email" to "new". Also change this in the weave-router types
export type EditorView = 'editor' | 'compose' | 'templates' | 'new-email';

export type SaveAs = (state: Campaign, saveAsStatus: CampaignStatus) => Promise<string>;

export type UnsavedChangesProps = {
  modalProps: ModalControlModalProps;
  proceed: () => void;
  setChangesExist: Dispatch<SetStateAction<boolean>>;
};

export type DayToSend = 'sunday' | 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday';

export enum SendType {
  SendAll = 'send-all',
  SendSpecific = 'send-specific',
}

export type Step = {
  id: StepId;
  Component: ReactElement;
  collapsedValue: ReactElement;
  readValue?: ReactElement;
  hide?: boolean;
};

export type StepId = 'title' | 'locations' | 'when-to-send' | 'content' | 'audience' | 'attachments';

export type AttachmentFieldProps = FieldProps<
  {
    attachments: {
      type: 'multiselect';
    };
  },
  'attachments'
>;
export type DateFieldProps = FieldProps<
  {
    date: {
      type: 'date';
    };
  },
  'date'
>;

export type DaysToSendFieldProps = FieldProps<
  {
    daysToSend: {
      type: 'checklist';
    };
  },
  'daysToSend'
>;

export type LocationIdsFieldProps = FieldProps<
  {
    locationIds: {
      type: 'checklist';
    };
  },
  'locationIds'
>;
export type TimeFieldProps = FieldProps<
  {
    time: {
      type: 'time';
    };
  },
  'time'
>;
